//This is to prevent dragging inside the container from working
export const toggleParentDraggableAttribute = (val: boolean) => {
  const draggableNodeList = document.querySelectorAll('[draggable]')
  for (let i = 0; i < draggableNodeList.length; i++) {
    const node = draggableNodeList[i]
    node.setAttribute('draggable', String(val))
  }
}
